// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1zmeV","icon":"SortAdornment_icon__1_lvV","up":"SortAdornment_up__M_q7d","down":"SortAdornment_down__3Bf4A","active":"SortAdornment_active__B1x7j"};